function cardHtml(ctx, it) {
    return `<article class="fq-card"${ctx.reveal(it.idx)}><span class="fq-num" aria-hidden="true">${it.num}</span><h3 class="fq-q">${it.q}</h3><div class="fq-a">${it.aHtml}</div></article>`;
}
const postcard = {
    id: 'postcard',
    name: 'Postcard',
    tag: 'Framed answer cards',
    styleTag: 'Playful editorial',
    description: 'Numbered cards with stamp-like badges, serif headings, and offset shadows. Every answer stays visible in a friendly grid made for shops and creative portfolios.',
    layout: 'cards',
    defaultAccent: '#b24b32',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        return {
            html: `<div class="fq-wrap"><div class="fq-head"><h2 class="fq-title">${ctx.title}</h2>${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}</div><div class="fq-grid">${ctx.items.map((it) => cardHtml(ctx, it)).join('')}</div></div>`,
            css: `
.FQM .fq-wrap{max-width:900px;margin:0 auto;padding:0 6px 6px 0;overflow-wrap:anywhere}
.FQM .fq-head{max-width:580px;margin-bottom:30px}
.FQM .fq-title{margin:0 0 12px;font-family:${ctx.v.head};font-size:38px;font-weight:500;line-height:1.13;letter-spacing:-.02em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.65;color:${ctx.v.sub}}
.FQM .fq-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,300px),1fr));gap:24px}
.FQM .fq-card{min-width:0;padding:24px;border:1px solid ${ctx.v.ink};border-radius:${ctx.v.radius};background:${ctx.v.card};box-shadow:5px 5px 0 ${ctx.v.soft}}
.FQM .fq-num{display:inline-grid;place-items:center;min-width:38px;height:38px;margin-bottom:20px;padding:4px;border:1px dashed ${ctx.v.accent};border-radius:calc(${ctx.v.radius} * .5);font-family:${ctx.v.mono};font-size:12px;color:${ctx.v.accent}}
.FQM .fq-q{margin:0 0 12px;font-family:${ctx.v.head};font-size:23px;font-weight:550;line-height:1.3;color:${ctx.v.ink}}
.FQM .fq-a{font-size:14.5px;line-height:1.75;color:${ctx.v.sub}}
`,
        };
    },
};
export default postcard;
